import { Controller } from "@hotwired/stimulus"
import ClipboardJS from 'clipboard'
import * as bootstrap from 'bootstrap'

export default class extends Controller {
  connect() {
    // Initialize tooltips for all sharing buttons
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

    // Set up clipboard functionality for the share icon
    var button = this.element
    button.setAttribute("data-clipboard-text", window.location.href)
    var clipboard = new ClipboardJS(this.element)

    var tooltip = bootstrap.Tooltip.getOrCreateInstance('#' + this.element.id)

    clipboard.on('success', function(e) {
      tooltip.setContent({ '.tooltip-inner': 'Copied!' })
      e.clearSelection()
      setTimeout(function() {
        tooltip.setContent({ '.tooltip-inner': 'Copy link to clipboard' })
      }, 5000);
    })
  }
}
